/**
 * @generated SignedSource<<7558fd5e00a78c35e1640891240db005>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "colorId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "colorId",
        "variableName": "colorId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteColor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteColorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteColorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9b3a04602969c3e62b348a836f756047",
    "id": null,
    "metadata": {},
    "name": "DeleteColorMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteColorMutation(\n  $colorId: ID!\n) {\n  deleteColor(colorId: $colorId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "aec468b8d8a3a56c2c28edadd4cc3f22";

export default node;
